import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { money } from "@/lib/format";

function KPI({ label, value, testId }) {
  return (
    <div className="bg-white border border-zinc-200 rounded-xl p-5 hover:border-teal-300 hover:shadow-[0_4px_16px_rgba(0,0,0,0.04)] transition-all" data-testid={testId}>
      <div className="text-xs font-heading uppercase tracking-wide text-zinc-400 mb-2">{label}</div>
      <div className="font-serif text-2xl text-zinc-900">{value}</div>
    </div>
  );
}

export default function AdminDashboard() {
  const [d, setD] = useState(null);

  useEffect(() => {
    api.get("/admin/dashboard").then((res) => setD(res.data));
  }, []);

  if (!d) return <div className="p-10 text-zinc-400">Loading dashboard…</div>;

  return (
    <div className="p-8" data-testid="admin-dashboard-page">
      <h1 className="font-serif text-3xl mb-8 text-zinc-900">Dashboard</h1>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
        <KPI label="Sales Today" value={money(d.sales_today)} testId="kpi-sales-today" />
        <KPI label="Sales This Week" value={money(d.sales_week)} testId="kpi-sales-week" />
        <KPI label="Sales This Month" value={money(d.sales_month)} testId="kpi-sales-month" />
        <KPI label="Orders" value={d.total_orders} testId="kpi-orders" />
        <KPI label="Average Order Value" value={money(d.average_order_value)} testId="kpi-aov" />
        <KPI label="Gross Margin" value={`${d.gross_margin_pct}%`} testId="kpi-margin" />
        <KPI label="Inventory Value" value={money(d.inventory_value)} testId="kpi-inventory-value" />
        <KPI label="Live Products" value={d.live_products} testId="kpi-live-products" />
        <KPI label="Awaiting Preparation" value={d.items_awaiting_preparation} testId="kpi-awaiting-prep" />
        <KPI label="Seller Submissions" value={d.seller_submissions_review} testId="kpi-submissions" />
        <KPI label="Offers Awaiting Response" value={d.offers_awaiting_response} testId="kpi-offers-awaiting" />
        <KPI label="Store Credit Outstanding" value={money(d.store_credit_outstanding)} testId="kpi-credit-outstanding" />
      </div>

      <h2 className="font-heading text-xs uppercase tracking-wide mb-4 text-zinc-500">Alerts</h2>
      <div className="space-y-2" data-testid="admin-alerts">
        {d.alerts.length === 0 && <p className="text-sm text-zinc-400">All caught up — no alerts right now.</p>}
        {d.alerts.map((a, i) => (
          <Link key={i} to={a.link} className="block bg-white border border-zinc-200 rounded-xl p-4 text-sm text-zinc-800 hover:border-teal-400 transition-colors" data-testid={`alert-${i}`}>
            {a.message}
          </Link>
        ))}
      </div>
    </div>
  );
}
